import React from 'react';
import { useForm } from 'react-hook-form';
import FormButton from '../Form/FormButton';
import FormInput from '../Form/FormInput';
import FormLabel from '../Form/FormLabel';

export interface Props {
  onSubmit: (data: any) => void;
}

export default function LoginForgetPassword(props: Props) {
  const { register, handleSubmit, errors } = useForm();

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <FormLabel>
        Ingresa la dirección de correo electrónico asociada a tu cuenta y te
        enviaremos un enlace para restablecer tu contraseña.
      </FormLabel>
      <FormInput
        type="email"
        name="email"
        placeholder="Correo electrónico"
        error={
          errors.email?.type === 'required'
            ? 'Debes indicar un correo electrónico.'
            : errors.email?.type === 'pattern'
            ? 'Debes indicar un correo electrónico válido.'
            : null
        }
        inputRef={register({
          required: true,
          pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
        })}
      />

      <FormButton type="submit" variant="contained" fullWidth>
        Enviar
      </FormButton>
    </form>
  );
}
